import api from "./api";

/** 获取用户积分 */
export const pointGet = async (agentId?: string): Promise<number> => {
  const res = await api.get<number>('/point/get', {}, agentId ? {
    headers: {
      'Team-Code': agentId || '',
    },
  } : {});
  return res.data;
}